module.exports = __webpack_public_path__ + "static/img/training_equipment.8ffa9449.png";